import React, { useState } from "react";
import { FaCheckCircle, FaArrowDown, FaEnvelope, FaPhone } from "react-icons/fa";
import { motion } from "framer-motion";

import { useParams } from "react-router-dom";

import {
  DetailCard,
  Footer,
  FilterModal,
  Navbar,
  PreviewModal,
  SearchBar,
  Loader,
} from "../../Components";
import { useGetFilterAdvertiseQuery } from "../../Services/AdvertiseService";
import { useApp } from "../../Context";

export default function DetailPage() {
  const { city } = useParams();
  const { filters, searchMode } = useApp();

  //services
  const { data: advertises, isLoading } = useGetFilterAdvertiseQuery({
    city: city ? city : filters.city,
    minArea: filters.minArea,
    maxArea: filters.maxArea,
    minUsableArea: filters.minUsableArea,
    maxUsableArea: filters.maxUsableArea,
    rooms: filters.rooms,
    minPrice: filters.minPrice,
    maxPrice: filters.maxPrice,
    minConstructionYear: filters.minConstructionYear,
    maxConstructionYear: filters.maxConstructionYear,
    advertise_type: filters.advertise_type,
    category: filters.category,
    sub_category: filters.sub_category,
    furnishing: filters.furnishing,
    searchMode: searchMode,
    name: filters.name,
    email: filters.mail,
    notes: filters.notes,
  });

  const [showFilter, setShowFilter] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [selectedAdData, setSelectedAdData] = useState(null);

  const handleShowFilter = () => setShowFilter((prevState) => !prevState);
  // const handleShowPreview = () => setShowPreview((prevState) => !prevState);

  const handleShowPreview = (adData) => {
    setSelectedAdData(adData);
    setShowPreview(true);
  };

  const handleClosePreview = () => {
    setSelectedAdData(null);
    setShowPreview(false);
  };

  return (
    <>
      <Navbar />
      {isLoading && <Loader isLoading={isLoading} text="Loading..." />}

      <div className="bg-lightGreen mt-14 p-4  flex items-center justify-center">
        <div>
          <SearchBar handleShowFilter={handleShowFilter} />
        </div>
      </div>
      {searchMode === 'create-request' && (
        <div className="bg-white rounded-lg shadow-lg lg:mx-20 sm:mx-5 my-10 overflow-hidden">
          <div className="bg-primary text-white p-6">
            <div className="flex items-center justify-center mb-4">
              <FaCheckCircle className="text-4xl mr-4" />
              <h2 className="text-3xl font-helvetica font-bold">Bestätigung</h2>
            </div>
          </div>
          
          <div className="p-8 bg-gradient-to-b from-primary-light/40 to-white">
            <motion.div 
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="mb-6"
            >
              <h3 className="text-2xl font-helvetica font-bold text-primary mb-4 text-center">
                Dein Gesuch wurde erfolgreich registriert!
              </h3>
              <p className="text-lg text-primary text-center mb-4">
                Wir haben deine Anfrage registriert.
              </p>
              <p className="text-md text-gray-600 text-center">
                Unsere Immobilienvermittler werden dich in Kürze mit passenden Angeboten kontaktieren.
              </p>
            </motion.div>

            <div className="flex justify-center my-8">
              <motion.div 
                animate={{ y: [0, 10, 0] }} 
                transition={{ repeat: Infinity, duration: 2 }}
              >
                <FaArrowDown className="text-4xl text-primary" />
              </motion.div>
            </div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.8 }}
              className="bg-primary-light rounded-lg p-6 border-l-4 border-primary"
            >
              <h4 className="text-xl font-helvetica font-bold text-primary mb-3">
                Passende Immobilien für dich
              </h4>
              <p className="text-primary mb-4">
                Unten findest du bereits verfügbare Angebote, die deinen Suchkriterien entsprechen.
                Du kannst die Anbieter direkt kontaktieren oder deine Suche weiter verfeinern.
              </p>

            </motion.div>
          </div>
        </div>
      )}
<div className="lg:px-12 sm:px-5 mb-6">
  <div className="flex items-center gap-3 border-b border-gray-200 pb-3">
    <h3 className="text-2xl font-helvetica font-bold text-primary">Verfügbare Angebote</h3>
    <span className="bg-primary text-white text-sm py-1 px-3 rounded-full">
      {advertises?.length} Ergebnisse
    </span>
  </div>
</div>
      
      <div className="lg:px-12 sm:px-5  flex flex-col gap-4 mb-4">
        {advertises?.map((item, idx) => (
          <DetailCard
            key={idx}
            data={item}
            onClick={() => handleShowPreview(item)}
          />
        ))}
      </div>

      <Footer />
      <FilterModal open={showFilter} handler={handleShowFilter} />
      {selectedAdData !== null && (
        <PreviewModal
          open={showPreview}
          handleClose={handleClosePreview}
          data={selectedAdData}
        />
      )}
    </>
  );
}
